export default "__VITE_ASSET__bc6f9ac3__"